// 主題切換(Account → 偏好)。spec 16 §6.1:預設跟隨系統,可手動 淺色/深色。
// 偏好非 React state 來源 → 用本地 state 種子自 localStorage,切換即套用 + 持久化。
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { THEME_PREFS, detectInitialTheme, setTheme, type ThemePref } from '../theme';

export function ThemeSwitcher() {
  const { t } = useTranslation();
  const [pref, setPref] = useState<ThemePref>(detectInitialTheme);
  return (
    <label style={{ display: 'flex', alignItems: 'center', gap: 'var(--spacing-3)' }}>
      <span>{t('account.theme')}</span>
      <select
        data-testid="theme-switcher"
        aria-label={t('account.theme')}
        value={pref}
        onChange={(e) => {
          const next = e.target.value as ThemePref;
          setPref(next);
          setTheme(next);
        }}
      >
        {THEME_PREFS.map((p) => (
          <option key={p.value} value={p.value}>
            {t(p.labelKey)}
          </option>
        ))}
      </select>
    </label>
  );
}
